export let API_GATEWAY_URI: string;

if (process.env.NODE_ENV === "development") {
  // API_MANAGEMENT_URI = "/api";
  // API_GATEWAY_URI = "/gateway";
  API_GATEWAY_URI = "https://alpha-gateway.blackvuecloud.com";
} else if (process.env.REACT_APP_ENV === "qa") {
  API_GATEWAY_URI = "https://alpha-gateway.blackvuecloud.com";
} else if (process.env.REACT_APP_ENV === "production") {
  API_GATEWAY_URI = "https://gateway.blackvuecloud.com";
}